import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Image,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const FundInFocusEmpoweringFintech: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus: Empowering Fintech Innovation: IIFL Fintech Fund's
          Impact on India’s Digital Economy
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Mehekka Oberoi, Fund Manager,
          <Link
            href="https://www.indiainfoline.com/fintech-fund"
            target="_blank"
            rel="noreferrer"
          >
            Fintech IIFL (India Infoline Group)
          </Link>
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member VC
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. In this exclusive chat with Mehekka Oberoi,
          Fund Manager, Fintech IIFL (India Infoline Group), she opined how IIFL
          Fintech Fund - India’s premier early-stage fintech-focused fund,
          spearheads innovation in financial services by supporting startups
          driving financial inclusion and digital transformation. With a robust
          portfolio attracting over $100M in follow-on funding and a strong
          track record of successful exits, IIFL leverages its conglomerate
          ecosystem to empower fintech and SaaS platforms. The fund aligns with
          IIFL Group’s vision to lead technological advancements, bridging gaps
          in domestic credit and insurance penetration while fuelling India's
          digital growth story.
        </Text>
      </Box>

      <Img
        src="https://static.levocdn.com/WGLBUT82/MehekkaOberoi-5AQCZxtuR7nu.jpg"
        alt="Perl"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="contain"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Mehekka Oberoi, Fund Manager,
            <Link
              href="https://www.indiainfoline.com/fintech-fund"
              target="_blank"
              rel="noreferrer"
            >
              Fintech IIFL (India Infoline Group).
            </Link>
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="start" mt="5px">
              <Link
                href="https://www.linkedin.com/in/mehekka-oberoi-735a48a1/"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. IIFL Fintech Fund has emerged as India’s only early-stage
            fintech-focused fund backed by a financial services conglomerate.
            What inspired the creation of such a specialized fund, and how does
            it align with IIFL Group's overall vision?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            IIFL as a Group comprises IIFL Finance, IIFL Securities & 5paisa.
            Through IIFL finance we cover the complete gamut of lending (gold
            loan, home loan, business loan and microfinance), IIFL Securities
            offers wealth management and broking services and 5paisa is amongst
            the top 10 discount brokers in India today. This makes us one the
            largest financial services conglomerate in India today. IIFL has
            been at the forefront of technological innovations ever since we
            started as a group. In our digital journey, we have partnered with a
            lot of early stage companies and become early adopters of their
            technology. We were the first one's in the country to have paperless
            branches. Multiple companies where we adopted the technology early
            on have become market leaders in the segment eg: Zoho, Perfios,
            Leegality, Finvu. <br /> <br />
            IIFL's vision is to continue to be at the forefront of technological
            innovation and partner with new age startups. Through this fund our
            idea is to give access to funding to the startups that we are
            working & collaborating with as well. IIFL is a client to the
            startups we have invested in, then makes it a win-win for both these
            companies and our clients. Our investee companies get the benefit of
            our distribution reach and testing their tech out at scale. And
            clients get access to these companies at an early stage.
          </Text>
        </Box>

        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. Why did the fund choose to prioritize early-stage fintech and
            SaaS platforms? What differentiates these sectors as high-potential
            investment areas in India?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              IIFL as a group collaborates and partners with the companies along
              with giving them access to funding. Since we are a financial
              services conglomerate our capability lies in assisting the fintech
              and SaaS platform companies that have use cases in financial
              services. Our distribution reach and scale can help these
              companies test their product and technology out at scale creating
              a win win for us and these startups. Our forte, mentorship, access
              and expertise lies in these areas. Additionally, fintech is the
              only segment in India which is expected to grow 11x vs Indian
              online retail and indian consumer tech that is expected to grow 5x
              and 3x respectively. Government focus is also on these segments
              from a technology standpoint :UPI which is going global, AEPS,
              BBPS, E-KYC, Digi locker, account aggregators are all Govt led
              initiatives.
            </Text>
          </Box>
        </Box>
        {/* Ques 3 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            3. With the significant gaps in domestic credit, and insurance
            penetration, how does IIFL Fintech Fund plan to bridge these through
            its portfolio companies?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Domestic credit and Insurance penetration is lower in India to the
              tune of 3x and 1.6x vs globally. There is enough headroom for
              penetration to go up across these segments. Through our fund we
              are looking to back technology infra players that can help with
              improving the penetration of these services further. Technology
              adoption is the only way through which a massive growth and
              penetration can be achieved.
            </Text>
          </Box>
        </Box>

        {/* Question 4 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            4. The fund’s portfolio companies have collectively attracted $100
            million+ in follow-on funding. Could you share some strategies or
            insights into how you position your portfolio companies to secure
            subsequent funding?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Subsequent funding is a function of company's performance and
              growth. We give our portfolio companies a complete access to
              IIFL's ecosystem. They get inputs on ways to enhance their product
              and technology, access to our business leadership team to get
              timely inputs on Marketing, sales, business. We help them with
              references that can help them showcase their product and
              technology to various other institutions. This helps them in
              growing their business and creating a market leadership position.
              Additionally, we have a large access to various funds due to our
              strong investment banking practice that helps make the required
              introductions.
            </Text>
          </Box>
        </Box>

        {/* Question 5 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            5. The fund achieved an 80% Return on one exit in under 18 months.
            What were the key factors that enabled this successful exit, and how
            do you evaluate exit opportunities for your investments?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              The company that we exited from our portfolio was Trustcheckr,
              this got acquired by Truecaller. Trustcheckr was a fraud detection
              platform, that had strong capabilities to identify fraud using
              mobile number and social footprints of the users. Truecaller was
              looking to enter India with an enterprise level solution and were
              thus evaluating options. Trustcheckr's platform could have got
              enhanced with Truecallers data and this led to a win win situation
              for both companies. For the fund, we have 3 pronged exit strategy-
              since we come at an early stage and value the technology-
              acquisition, IPO and secondary stake sale are exit strategies for
              the fund.
            </Text>
          </Box>
        </Box>

        {/* Question 6 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            6. GrayQuest, another portfolio company, focuses on digital
            financial solutions for India’s education ecosystem. What was your
            investment thesis for GrayQuest, and how do you see fintech shaping
            education in India?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              School fees is on an upward trend in India and is becoming a major
              expenditure for all households. Parents are looking for easy
              payment plans to reduce their burden. And hence there is a need
              for companies like Grayquest. That are focused on giving parents a
              no cost EMI options to make school fees payment. At the same time,
              schools do not have a collection infrastructure to collect in case
              a parent defaults while these fintechs have means for collections.
              And hence by giving a small upfront fees discount school gets
              benefited without any collection responsibility. This make it's a
              win win proposition for both schools and the parents. A solution
              like this over long term will lead a lot of parents being able to
              afford even schools that have a little higher fees and provide
              better education environment. This makes, Grayquest an exciting
              bet for us.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            7. How does IIFL Fintech Fund envision contributing to India’s
            broader financial inclusion and digital transformation goals?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              IIFL fintech fund is at the forefront of supporting startups that
              are building for financial inclusion and digital transformation.
              Our portfolio companies comprise of players that cover the
              complete digital stack in India- <strong>Leegality</strong>{' '}
              (digital signing), <strong>Finvu </strong> (account aggregator-
              digital data transfer), <strong>Data Sutram</strong> (Fraud
              detection), <strong>Finarkein Analytics </strong> (Digital Data
              transfer ), <strong>Finbox</strong>(Infra for growing financial
              inclusion through lending), <strong>Riskcovry</strong> (Infra for
              supporting financial inclusion in Insurance),{' '}
              <strong>Insurance Samadhan</strong>
              (Insurance grievance redressal), <strong>Trendlyne</strong>{' '}
              (improving financial awareness and analysis),{' '}
              <strong>Castler</strong> (Digital transformation for escrow
              banking), <strong>Xtracap Fintech</strong> (improving financial
              penetration for tier 2 and tier 3 MSMEs in India). Our Philosophy
              is to support these startups that are building for India and
              India's growth and digital transformation journey in the financial
              services space.
            </Text>
          </Box>
        </Box>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default FundInFocusEmpoweringFintech;
